// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module__button___2AESl"};